module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-old-9131257f01312f633aaf928dcd305475.png";